<template>
  <img :src="src" class="icon" :title="title" :alt="alt">
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.icon {
  min-width: 28px;
  min-height: 28px;
  cursor: pointer;
}
</style>
